import { mixins, styled, SvgIcon } from '@bob/library'
import { matomo } from '@websrc/App/Tracking/Matomo'
import { itemText } from '@websrc/MainTopbar/MenuList/TopbarMenu.css'
import clsx from 'clsx'
import React, { useState } from 'react'

import { linkItem, menuExpandBtn, svg } from './MobileMenuAccordion.css'

export interface MobileMenuAccordionProps {
  title: string
  links: {
    title: string
    href?: string
    onClick?: () => void
  }[]
}

const Wrapper = styled.div`
  & > a {
    ${mixins.padding.left(30)}
  }
`

export const MobileMenuAccordion = ({ title, links }: MobileMenuAccordionProps) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Wrapper>
      <button className={clsx(menuExpandBtn, itemText)} onClick={() => setIsOpen(!isOpen)}>
        <span style={{ color: isOpen ? '#005AD2' : 'black' }}>{title}</span>
        <SvgIcon
          className={svg}
          color={isOpen ? 'blue6' : 'black'}
          name={isOpen ? 'ARROW_UP' : 'ARROW_DOWN'}
          size={14}
          strokeWidth={4}
        />
      </button>
      {isOpen &&
        links.map((link, i) => (
          <a
            className={clsx(linkItem, itemText)}
            href={link.href}
            key={i}
            onClick={() => {
              matomo.trackEvent('engagement', 'all', ['top menu'], [title, link.title], 'menu')
              link.onClick?.()
            }}
          >
            {link.title}
          </a>
        ))}
    </Wrapper>
  )
}
